import { render } from "./RatiosPanel.vue?vue&type=template&id=5195ae2c&scoped=true"
import script from "./RatiosPanel.vue?vue&type=script&lang=js"
export * from "./RatiosPanel.vue?vue&type=script&lang=js"

import "./RatiosPanel.vue?vue&type=style&index=0&id=5195ae2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5195ae2c"]])

export default __exports__